import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { IconQrcode } from "@tabler/icons-react";
import { KeyConstant, LangConstant } from "const";
import { StorageUtils } from "utils";
import { PaperHeader } from "components";
import { useGetBranchQR } from "hooks";
import CreateQRDialog from "./CreateQRDialog";

const QRServerSection = () => {
  const { t: getLabel } = useTranslation();
  const { getBranchQR } = useGetBranchQR();

  const currentBranchExpiryTime = StorageUtils.getStoreData(KeyConstant.KEY_BRANCH_QR_EXPIRY_TIME);

  const [msgQR, setMsgQR] = useState("");
  const [isQRExpired, setIsQRExpired] = useState(false);
  const [isOpenQRDialog, setIsOpenQRDialog] = useState(false);
  const [dataQR, setDataQR] = useState(null);

  const downloadQR = () => {
    const link = document.createElement("a");
    link.href = dataQR;
    link.download = "qr.png";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    if (currentBranchExpiryTime) {
      if (currentBranchExpiryTime <= Date.now()) {
        setMsgQR(getLabel(LangConstant.TXT_QR_EXPIRED));
        setIsQRExpired(true);
      } else {
        const date = new Date(currentBranchExpiryTime);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        setMsgQR(getLabel(LangConstant.TXT_QR_VALID_UNTIL, { date: `${day}/${month}/${year}` }));
        setIsQRExpired(false);
      }
    }
  }, [currentBranchExpiryTime]);

  useEffect(() => {
    const fetchQrCode = async () => {
      if (currentBranchExpiryTime && currentBranchExpiryTime >= Date.now()) {
        const qr = await getBranchQR({ qr_expiry_time: currentBranchExpiryTime });
        setDataQR(qr);
      }
    };
    fetchQrCode();
  }, [currentBranchExpiryTime]);

  return (
    <div>
      <PaperHeader icon={<IconQrcode size={24} className="text-primary" />} title={getLabel(LangConstant.TXT_QR_SERVER)} />

      <div className="d-flex align-items-start gap-3">
        {Boolean(dataQR) && <img style={{ width: "300px" }} src={dataQR} alt="QR Code" />}
        <button className="btn btn-primary d-flex align-items-center gap-2 mt-3" onClick={() => setIsOpenQRDialog(true)}>
          <IconQrcode size={18} /> {getLabel(LangConstant.TXT_CREATE_QR)}
        </button>
      </div>

      <button
        className="btn btn-primary mt-2 mb-2"
        style={{ width: "300px" }}
        onClick={downloadQR}
        disabled={!Boolean(dataQR)}
      >
        {getLabel(LangConstant.TXT_SAVE_QR)}
      </button>

      <p className={isQRExpired ? "text-danger" : ""}>{msgQR}</p>

      <CreateQRDialog open={isOpenQRDialog} onClose={() => setIsOpenQRDialog(false)} />
    </div>
  );
};

export default QRServerSection;
